import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PAGE_SEO, FAQS } from "@/data/seoData";
import { BRAND, EMAIL, PHONE_TEL } from "@/lib/site";

const SITE_URL = process.env.REACT_APP_SITE_URL;
if (!SITE_URL) throw new Error("REACT_APP_SITE_URL is required");
const setMeta = (key, content, attribute = "name") => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
  element.setAttribute("content", content);
};
export const Seo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/$/, "") || "/";
    const page = PAGE_SEO[path];
    const meta = page || { title: `Private or unavailable page | ${BRAND}`, description: "Reserve Cheap Flights travel assistance." };
    const url = new URL(path, SITE_URL).href;
    document.title = meta.title;
    setMeta("description", meta.description);
    setMeta("robots", page ? "index, follow, max-image-preview:large" : "noindex, nofollow");
    setMeta("og:title", meta.title, "property"); setMeta("og:description", meta.description, "property");
    setMeta("og:url", url, "property"); setMeta("og:type", "website", "property");
    setMeta("og:image", new URL("/img/hero-home.jpg", SITE_URL).href, "property");
    setMeta("og:site_name", BRAND, "property"); setMeta("og:locale", "en_US", "property");
    setMeta("twitter:card", "summary_large_image"); setMeta("twitter:title", meta.title); setMeta("twitter:description", meta.description);
    setMeta("twitter:image", new URL("/img/hero-home.jpg", SITE_URL).href);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = url;
    document.getElementById("site-structured-data")?.remove();
    if (!page) return;
    const graph = [{ "@type": "TravelAgency", "@id": `${SITE_URL}/#agency`, name: BRAND, url: SITE_URL, email: EMAIL, telephone: PHONE_TEL.replace("tel:", ""), logo: new URL("/favicon.svg", SITE_URL).href, areaServed: { "@type": "Country", name: "United States" } }];
    graph.push({ "@type": "WebSite", "@id": `${SITE_URL}/#website`, name: BRAND, url: SITE_URL, inLanguage: "en-US" });
    if (path === "/" || path === "/flights") graph.push({ "@type": "FAQPage", mainEntity: FAQS.map(([name, text]) => ({ "@type": "Question", name, acceptedAnswer: { "@type": "Answer", text } })) });
    const script = document.createElement("script"); script.id = "site-structured-data"; script.type = "application/ld+json"; script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph }); document.head.appendChild(script);
  }, [pathname]);
  return null;
};